import React, { useCallback, useEffect, useState } from 'react'
import ModalCustom from '../../../../components/modal/modalCustomCms';
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Tabs, Typography } from '@mui/material';
import { CustomTab, projectTabsProps } from './TabCustom';
import { colors } from '../../../../constants/colors';
import StateComponents from '../../../../components/state-component/StateComponents';
import ContainerButton from '../../../../components/button/ContainerButton';
import { listMedia, MediaApi } from '../../../../api/media-file/MediaFile.api';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { IconComponents } from '../../../../assets/icons/icons';
import { BoxFolder } from '../style/StyleMedia';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { getBaseApi, MEDIA_ENUM } from '../../../../utils/app.utils';
import { UploadImagePreview } from '../../../../components/upload-image-preview/UploadImagePreview';
// import { motion } from 'framer-motion'
import CheckBoxCustom from '../../../../components/checkbox/CheckBoxCustom';
import clsx from 'clsx';
import { TransitionGroup } from "react-transition-group";
import { markTotalFileCounts } from '../../setting/manage-file/ManageFile';
import { useTranslation } from 'react-i18next';

type Props = {
    handleClose: () => void;
    open: boolean;
    title: string;
    sub_title?: string;
    id_media_file: number | null,
    onSelectMediaFile?: (id_media: number, id_media_file: number | null, media_file_path?: string, media_file_name?: string, media_file_size?: string, media_file_type?: string) => void,
    onSubmitLocalFile?: (id_media_file: number, media_file_path?: string, media_file_name?: string, media_file_type?: string, media_file_size?: string) => void;
    onSubmitMediaFile?: (id_media: number, id_media_file: number, media_file_path?: string, media_file_name?: string) => void;
    multiple?: boolean;
    onSubmitMediaFileMultiple?: (media_file: any[]) => void;
    select_one?: boolean;
    disabled_submit_button?: boolean;
}

// const containerVariants = {
//     hidden: {},
//     show: {
//         transition: {
//             staggerChildren: 0.15,
//         },
//     },
// };

// const itemVariants = {
//     hidden: { opacity: 0, x: -30 },
//     show: (i: number) => ({
//         opacity: 1,
//         x: 0,
//         transition: {
//             delay: i * 0.1,
//             duration: 0.5,
//             ease: "easeOut",
//         },
//     }),
// };

const ModalMedia: React.FC<Props> = ({
    handleClose,
    open,
    title,
    sub_title,
    onSelectMediaFile,
    id_media_file,
    onSubmitLocalFile,
    onSubmitMediaFile,
    multiple,
    onSubmitMediaFileMultiple,
    select_one,
    disabled_submit_button
}: Props) => {
    const { t } = useTranslation();
    const base_image_url = getBaseApi()
    const dispatch = useDispatch();
    const [step, setStep] = useState<number>(0);
    const [loadedMap, setLoadedMap] = useState<Record<string, boolean>>({});

    const [multi_file, set_multi_file] = useState<any[]>([]);

    const [select_file_local, set_select_file_local] = useState<File[]>([]);
    const [treeListData, setTreeListData] = useState<any[]>([]);
    const [id_media, set_id_media] = useState<number | null>(null);
    const [media_files, set_media_files] = useState<any[]>([]);
    const [id_media_data, set_id_media_data] = useState<number[]>([]);

    const [checked, setChecked] = useState<number[]>([]);

    const [keyword, set_keyword] = useState<string>("");
    const [keyword_submit, set_keyword_submit] = useState<string>("");

    const handleChangeSelected = (id_media_file: number) => {
        if (checked?.some((x) => x === id_media_file)) {
            setChecked((prev) => prev.filter((x) => x !== id_media_file))
        } else {
            setChecked((prev) => ([...prev, id_media_file]))
        }
    }
    const handleChangeProjectTabs = (_: React.SyntheticEvent, newValue: number) => setStep(newValue)

    const handleGetTreeList = useCallback(async () => {
        dispatch(setLoading());
        let query: listMedia = {}
        if (keyword_submit) query = { ...query, keyword: keyword_submit }
        await MediaApi.treeList(query).then((res) => {
            if (res.status < 300) {
                // const data = res.data?.data || [];
                const data = res.data?.data?.map(markTotalFileCounts) || []
                setTreeListData(data);
                set_media_files([]);
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [keyword_submit])

    const handleGetMediaFile = async (id_media_value: number) => {
        dispatch(setLoading());
        await MediaApi.getMediaFile(id_media_value).then((res) => {
            if (res.status < 300) {
                const media_files_data = res.data?.data?.media_files;
                set_media_files(media_files_data || [])
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    const handleOpenMedia = (id_media_value: number) => {
        if (id_media_value === id_media) {
            set_id_media(null);
        }
        const has_id: boolean = id_media_data.some((x) => x === id_media_value);
        if (has_id) {
            set_id_media_data((prev) => prev?.filter((x) => id_media_value !== x))
        } else {
            set_id_media_data((prev) => ([...prev, id_media_value]))
        }
    }

    const handleSubmitFileMedia = () => {
        if (onSubmitMediaFile && id_media && id_media_file) {
            onSubmitMediaFile(id_media, id_media_file)
        }
    }
    const handleSubmitLocalFile = async (): Promise<number | undefined> => {
        try {
            if (onSubmitLocalFile && select_file_local?.length > 0) {
                dispatch(setLoading());
                const formDataValue: FormData = new FormData();
                formDataValue.append("files", select_file_local[0]);
                // id_media_2 2 สำหรับไฟล์ในเครื่อง
                const id_media_file_value: any = await MediaApi.createFile(MEDIA_ENUM.LOCAL_FILE, formDataValue).then((res) => res.data?.data?.find((x: any) => x)).finally(() => {
                    dispatch(unsetLoading());
                })
                onSubmitLocalFile(id_media_file_value?.id_media_file, id_media_file_value?.media_file_path, id_media_file_value?.media_file_name, id_media_file_value?.media_type_type, id_media_file_value?.media_file_size)
            } else {
                return undefined
            }
        } catch (err) {
            console.log(err)
        }
    }

    const handleSubmitKeyword = () => {
        set_keyword_submit(keyword)
    }

    const handleSubmitMultipleFileLocal = async () => {
        try {
            let file_upload_data: any[] = []
            if (onSubmitLocalFile && multi_file?.length > 0) {
                dispatch(setLoading());
                const promise_uploaded = multi_file?.map(async (list) => {
                    const formDataValue: FormData = new FormData();
                    formDataValue.append("files", list);
                    const response = await MediaApi.createFile(MEDIA_ENUM.LOCAL_FILE, formDataValue);
                    return response?.data?.data?.find((x: any) => x) || null
                })
                const result_uploaded: any[] = await Promise.all(promise_uploaded) || []
                onSubmitMediaFileMultiple && onSubmitMediaFileMultiple(result_uploaded)
                dispatch(unsetLoading());
                handleClose();
                set_multi_file([]);
            } else {
                onSubmitMediaFileMultiple && onSubmitMediaFileMultiple([]);
                return file_upload_data
            }
        } catch (err) {
            console.log(err)
        }
    }


    const handleSubmitMultipleFile = () => {
        const media_data_value: any[] = media_files?.filter((x) => checked.includes(x?.id_media_file))?.map((list: any) => {
            return {
                ...list,
                is_image: true
            }
        });
        if (onSubmitMediaFileMultiple) {
            onSubmitMediaFileMultiple(media_data_value);
            handleClose();
            setChecked([]);
        }
    }

    const handleChangeFileImage = (newFile: any) => {
        const newArray = Array.isArray(newFile) ? newFile : [newFile];
        if (newFile?.length > 0) {
            set_multi_file([...multi_file, ...newArray])
        } else {
            set_multi_file([...multi_file, newFile])
        }
    }

    useEffect(() => {
        handleGetTreeList();
    }, [handleGetTreeList])


    const renderFile = (subMedia: any[], pl: number): React.ReactNode => {
        return (
            <List component="div" disablePadding>
                {subMedia.map((media: any, index: number) => {
                    return (
                        <>
                            <ListItemButton className='flex justify-between items-center' key={media?.id_menu + index} sx={{ ml: pl }} onClick={() => {
                                handleGetMediaFile(media?.id_media);
                                handleOpenMedia(media?.id_media);
                                set_id_media(media?.id_media)
                            }}>
                                <span className='flex flex-1 w-full'>
                                    <ListItemIcon>
                                        <ArrowForwardIosIcon sx={{
                                            transform: (id_media_data?.includes(media?.id_media) && media?.children?.length) > 0 ? "rotate(90deg)" : "",
                                            transition: "all .5s ease"
                                        }} className={clsx('', {
                                            'text-active_color': id_media === media?.id_media
                                        })} />
                                        {id_media === media?.id_media ? (
                                            <IconComponents.FolderActive />
                                        ) : (
                                            <IconComponents.FolderInActive />
                                        )}
                                    </ListItemIcon>
                                    <ListItemText className={clsx('', {
                                        'text-active_color': id_media === media?.id_media
                                    })} primary={media?.media_name} />
                                </span>
                                <span className='flex-1 flex items-center justify-end'>
                                    <Typography>
                                        {media?.total_file_count || "0"}
                                    </Typography>
                                </span>
                            </ListItemButton>
                            {media?.children?.length > 0 && (
                                <div className='w-full'>
                                    <TransitionGroup >
                                        {id_media_data?.includes(media?.id_media) && (
                                            <Collapse timeout="auto" unmountOnExit>
                                                {renderFile(media?.children, pl + 2)}
                                            </Collapse>
                                        )}
                                    </TransitionGroup>
                                </div>
                            )}
                        </>
                    )
                })}
            </List>
        )
    }
    return (
        <ModalCustom
            open={open}
            onClick={() => step === 0 ?
                (multiple && step === 0) ? handleSubmitMultipleFile() : handleSubmitFileMedia()
                : (multiple && step === 1) ? handleSubmitMultipleFileLocal() : handleSubmitLocalFile()
            }
            title={title}
            scrollBody
            handleClose={() => {
                handleClose();
                setChecked([]);
            }}
            subTitle={sub_title || t('กรุณาเลือกรายการที่ท่านต้องการ')}
            maxWidth='xl'
            disabledSubmitButton={
                (multiple && checked?.length === 0 && step === 0)
                || (step === 0 && !multiple && (!id_media_file || !id_media))
                || (step === 1 && select_file_local?.length === 0 && !multiple)
                || (step === 1 && multiple && multi_file?.length === 0)
                || disabled_submit_button
            }
            form={
                <div className='w-full my-5' >
                    <Tabs
                        TabIndicatorProps={{ sx: { backgroundColor: colors.white, display: "flex", flexWrap: "wrap" } }}
                        value={step}
                        onChange={handleChangeProjectTabs}
                        aria-label="project-tabs">
                        {[t('เลือกจากโฟลเดอร์ในระบบ'), t('นำเข้าไฟล์จากเครื่อง')].map((list, index: number) => (
                            <CustomTab label={<Typography sx={{
                                color: step === index ? colors.white : colors.black
                            }}>{list}</Typography>} {...projectTabsProps(index)} />
                        ))}
                    </Tabs>
                    {
                        step === 0 && (
                            <div className='w-full mt-6 flex flex-col md:flex-row rounded-lg border-2 border-[#DDE1EB]'>
                                <span className='flex-1 w-full max-w-[500px] p-4'>
                                    <StateComponents
                                        typeProps={[
                                            {
                                                seq: 1,
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12,
                                                },
                                                fieldProps: {
                                                    onChange: (e) => set_keyword(e.target.value),
                                                    placeholder: t("ค้นหา"),
                                                    endAdornment: (
                                                        <ContainerButton
                                                            sxContainer={{ maxWidth: 100 }}
                                                            justifyContent='flex-end'
                                                            buttonData={[
                                                                {
                                                                    seq: 1,
                                                                    buttonProps: {
                                                                        onClick: handleSubmitKeyword
                                                                    },
                                                                    fullWidth: true,
                                                                    key: "SEARCH",
                                                                    label: t("ค้นหา"),
                                                                    type: "SEARCH"
                                                                }
                                                            ]}
                                                        />
                                                    )

                                                }
                                            }
                                        ]}
                                    />
                                    <Typography mt={2} mb={2} variant='h5'>
                                        {t("โฟลเดอร์")}
                                    </Typography>
                                    <div className='flex flex-col gap-2'>
                                        {treeListData?.map((list, index) => {
                                            return (
                                                <>
                                                    <BoxFolder onClick={() => {
                                                        set_id_media(list?.id_media);
                                                        handleGetMediaFile(list?.id_media);
                                                        onSelectMediaFile?.(list.id_media, null);
                                                        handleOpenMedia(list?.id_media);
                                                    }} key={index} className='w-full flex justify-between'>
                                                        <span className='flex w-full justify-start items-center gap-2'>
                                                            <ArrowForwardIosIcon
                                                                sx={{
                                                                    fontSize: "16px",
                                                                    color: id_media === list?.id_media ? colors.themeMainColorTwo : undefined
                                                                }}
                                                            />
                                                            {id_media === list?.id_media ? (
                                                                <IconComponents.FolderActive />
                                                            ) : (
                                                                <IconComponents.FolderInActive />
                                                            )}
                                                            {list.media_name || "-"}
                                                        </span>
                                                        <span>
                                                            <Typography>
                                                                {list?.total_file_count || "0"}
                                                            </Typography>
                                                        </span>
                                                    </BoxFolder>
                                                    {
                                                        list?.children?.length > 0 && (
                                                            <div className='w-full'>
                                                                <TransitionGroup >
                                                                    {id_media_data?.includes(list?.id_media) && (
                                                                        <Collapse timeout="auto" unmountOnExit>
                                                                            {renderFile(list?.children, 3)}
                                                                        </Collapse>
                                                                    )}
                                                                </TransitionGroup>
                                                            </div>
                                                        )
                                                    }
                                                </>
                                            )
                                        })}
                                    </div>
                                </span>
                                <span
                                    // variants={containerVariants}
                                    // initial="hidden"
                                    // animate="show"
                                    style={{
                                        display: 'grid',
                                        gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                                        gap: 2
                                    }} className='flex-1 w-full flex p-5'>
                                    {media_files?.map((list, index) => {
                                        // console.log(list, 'list')
                                        const isLoaded = loadedMap[list?.id_media_file];
                                        return <div
                                            // custom={index}
                                            // variants={itemVariants}
                                            onClick={() => handleChangeSelected(list?.id_media_file)}
                                            key={list?.id_media_file} className='flex relative w-full justify-center items-center flex-wrap max-w-[auto]'>
                                            {multiple && (
                                                <span className='flex z-10 text-white justify-center items-center rounded-md absolute top-[-1.1rem] right-[-2rem]'>
                                                    {(select_one && checked?.length > 0) ? (
                                                        <></>
                                                    ) : (
                                                        <CheckBoxCustom
                                                            label={t('เลือก')}
                                                            checked={checked.includes(list?.id_media_file)}
                                                            setChecked={() => handleChangeSelected(list?.id_media_file)}
                                                        />
                                                    )}
                                                </span>
                                            )}
                                            <img
                                                onLoad={() =>
                                                    setLoadedMap(prev => ({ ...prev, [list?.id_media_file]: true }))
                                                }
                                                loading='lazy'
                                                onClick={() => id_media && onSelectMediaFile?.(id_media, list?.id_media_file, list?.media_file_path, list?.media_file_name, list?.media_file_size, list?.media_file_type)}
                                                style={{
                                                    filter: (id_media_file !== list?.id_media_file && id_media_file && !multiple) ? "blur(2px)" : (select_one && id_media_file !== list?.id_media_file) ? "blur(2px)" : ""
                                                }}
                                                className={`object-contain hover:opacity-45 cursor-pointer duration-500 ${isLoaded ? 'blur-0 opacity-100' : 'blur-md opacity-30'} transition-all`}
                                                width={200} height={"auto"}
                                                src={`${base_image_url}/${list?.media_file_path}${list?.media_file_name}`}
                                                alt={`list-${index + 1}`}
                                            />
                                        </div>
                                    })}
                                </span>
                            </div>
                        )
                    }

                    {
                        step === 1 && (
                            <UploadImagePreview
                                image_file_blob={select_file_local[0]}
                                onChange={(file) => multiple ? handleChangeFileImage(file) : set_select_file_local(file)}
                                onClear={() => set_select_file_local([])}
                                multiple={multiple}
                                multi_file={multi_file}
                                onDeleteMultiFileUpload={(i) => {
                                    set_multi_file((prev) => prev.filter((_, index) => index !== i));
                                }}
                            />
                        )
                    }
                </div >
            }
        />
    )
}

export default ModalMedia